import React, { useEffect, useState } from "react";
import "./Devices.css";
import { useTheme } from "../theme/ThemeContext";
import DataTable from "react-data-table-component";
import omit from "lodash.omit";
import imggg1 from './model-img/5sw &fan.png6365054edeac1.png'
import imggg2 from './model-img/5sw &fan3d.png6365054ee8fee.png'
import imggg3 from './model-img/5sw and fan( 3d b).png6365054f003fe.png'
import imggg4 from './model-img/5sw and fan(w).png6365054f0f5a0.png'
import { Search } from "lucide-react";
import LoadingSpinner from "../Loading/LoadingSpinner";
import NotificationPopup from "../alertpopup/NotificationPopup";
const Devices = () => {
  const token = localStorage.getItem('authToken')
  const backendurl = window.location.hostname === 'localhost'
    ? ''
    : window.location.hostname === 'demo.ollinwon.com'
      ? process.env.REACT_APP_BACKEND_URL
      : window.location.hostname === 'iot.aizoteq.com'
        ? process.env.REACT_APP_BACKEND_URL2
        : '';

  const { theme } = useTheme();
  const [showPopup, setShowPopup] = useState(false);
  const [checkpopup, setCheckPopup] = useState(false)
  const [selectedColumns, setSelectedColumns] = useState(new Set());
  const [availableColumns, setAvailableColumns] = useState([]);
  const [selectedColumn, setSelectedColumn] = useState('');
  const [editData, setEditData] = useState(null);
  const [devices, setDevices] = useState([]);
  const [columns, setColumns] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [deletePopup, setDeletePopup] = useState(false);
  const [deleteData, setDeleteData] = useState(null);
  const [addPopup, setAddPopup] = useState(false);
  const [editPopup, setEditPopup] = useState(false)
  const [featurepopup, setfeaturepopup] = useState(false)
  const [featureImages, setFeatureImages] = useState([]);
  const [webImages, setWebImages] = useState([]);
  const [newFeature, setNewFeature] = useState("");
  const [mainImage, setMainImage] = useState(null)
  const [features, setFeatures] = useState([]);
  const [images, setImages] = useState([]);
  const [newImages, setNewImages] = useState([]);
  const [editImagePopup, setEditImagePopup] = useState(false);
  const [editFeaturePopup, setEditFeaturePopup] = useState(false)
  const [selectedFile, setSelectedFile] = useState(null);
  const [rawMaterials, setRawMaterials] = useState([]);
  const [components, setComponents] = useState([]);
  const [selectedComponent, setSelectedComponent] = useState("");
  const [requiredQty, setRequiredQty] = useState("");
  const [modelId, setModelId] = useState(null);
  const [modelIds, setModelIds] = useState(null)
  const [actionPopup, setActionPopup] = useState(false);
  const [actionData, setActionData] = useState(null);
  const [materials, setMaterials] = useState([]);
  const [Qty, setQty] = useState("");
  const [showrawDeletePopup, setShowrawDeletePopup] = useState(false);
  const [selectedRawMaterial, setSelectedRawMaterial] = useState(null);
  const [deleterawMaterials, setDeleteRawMaterials] = useState([]);
  const [userData, setUserData] = useState({})
  const [userRole, setUserRole] = useState(null);
  const [featureeditpopup, setfeatureeditpopup] = useState(false)
  const [featuredeletepopup, setfeaturedeletepopup] = useState(false)
  const [featureaddpopup, setfeatureaddpopup] = useState(false)
  const [feature, setFeature] = useState("");
  const [featureValue, setFeatureValue] = useState("");
  const [modelRow, setModelRow] = useState({ features: [] });
  const [selectedFiles, setSelectedFiles] = useState([]);

  const [descPopup, setDescPopup] = useState(false);
  const [descData, setDescData] = useState({
    product_id: "",
    title: "",
    description: "",
    short_description: "",
    category: "",
    type: "",
    specifications: [{ key: "", value: "" }],
    features: [""]
  });
  const [originalData, setOriginalData] = useState({});
  const [hasDescription, setHasDescription] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  // Add notification state
  const [notification, setNotification] = useState({
    show: false,
    type: "success",
    message: "",
    title: ""
  });

  // Add loading states
  const [loading, setLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");
  const [isDescLoading, setIsDescLoading] = useState(false);
  // Notification helper function
  const showNotification = (type, message, title = "", duration = 3000) => {
    setNotification({
      show: true,
      type,
      message,
      title
    });

    setTimeout(() => {
      setNotification(prev => ({ ...prev, show: false }));
    }, duration);
  };
  useEffect(() => {
    if (!hasDescription) return;

    const changed =
      JSON.stringify(descData) !== JSON.stringify(originalData);

    setIsEditing(changed);
  }, [descData]);

  const openDescPopup = async (product_id) => {
    setIsDescLoading(true);
    setLoadingText("Loading description...");

    try {
      const res = await fetch(`${backendurl}/dashboard/api/product/description/${product_id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (res.ok) {
        const data = await res.json();

        const specs = data.data.specifications
          ? Object.entries(data.data.specifications).map(([k, v]) => ({ key: k, value: v }))
          : [{ key: "", value: "" }];

        setDescData({
          ...data.data,
          specifications: specs,
          features: data.data.features || [""],
        });

        setOriginalData(data.data);
        setHasDescription(true);
      } else {
        setDescData({
          product_id,
          specifications: [{ key: "", value: "" }],
          features: [""]
        });
        setHasDescription(false);
      }

      setDescPopup(true);
    } catch (err) {
      console.error(err);
      showNotification("error", "Failed to load description", "Load Error");
    } finally {
      setIsDescLoading(false);
    }
  };
  const handleDeletewebImage = async (imageid) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this image?");
    if (!confirmDelete) return;

    setLoading(true);
    setLoadingText("Deleting image...");

    try {
      const response = await fetch(`${backendurl}/dashboard/api/delete/web/images/${imageid}`, {
        method: "DELETE",
        headers: {
          'Authorization': ` Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        setImages((prevImages) => prevImages.filter((image) => image.modelId !== modelId));
        showNotification("success", "Image deleted successfully!");
      } else {
        const data = await response.json();
        showNotification("error", data.message || "Failed to delete the image.", "Delete Failed");
      }
    } catch (error) {
      console.error("Error deleting image:", error);
      showNotification("error", "An error occurred while deleting the image. Please try again.", "Network Error");
    } finally {
      setLoading(false);
    }
  };

  const handleUploadwebimg = async (modelId) => {
    if (!selectedFiles.length) {
      showNotification("warning", "Please select images to upload", "No Images Selected");
      return;
    }

    setIsUploading(true);
    setLoadingText("Uploading images...");

    const formData = new FormData();
    Array.from(selectedFiles).forEach((file) => {
      formData.append("images", file);
    });

    try {
      const response = await fetch(`${backendurl}/dashboard/api/upload/webimage/${modelId}`, {
        method: "POST",
        body: formData,
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        const newFeatureImages = data.imagePaths.map((imageUrl, index) => ({
          id: Date.now() + index,
          images: [{ image_id: Date.now() + index, image_url: imageUrl }],
        }));

        setFeatureImages((prev) => [...prev, ...newFeatureImages]);
        setNewImages([]);
        setEditImagePopup(false);
        showNotification("success", "Images uploaded successfully!");
        fetchModelData(modelId);
      } else {
        const error = await response.json();
        showNotification("error", error.message || "Failed to upload images", "Upload Failed");
      }
    } catch (error) {
      console.error("Error uploading images:", error);
      showNotification("error", "Error uploading images", "Network Error");
    } finally {
      setIsUploading(false);
    }
  };

  const handleEditFeaturePopup = (row) => {
    setModelIds(row);
    setEditFeaturePopup(true);
  };

  const handlewebFileChange = (e) => {
    setSelectedFiles(e.target.files);
  };

  const fetchModelData = async (modelId) => {
    setLoading(true);
    setLoadingText("Loading model data...");

    try {
      const response = await fetch(`${backendurl}/dashboard/api/display/images/${modelId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setFeatureImages(data.feature_images || []);
      setWebImages(data.web_images || []);
      setModelId(data.model_id);
      if (data.feature_images && data.feature_images.length > 0) {
        setMainImage(`${backendurl}${data.feature_images[0].images[0].image_url}`);
      }
    } catch (error) {
      console.error("Error fetching model data:", error);
      showNotification("error", "Failed to load model data", "Load Error");
    } finally {
      setLoading(false);
    }
  };

  const handleImageClick = (imageUrl) => {
    setMainImage(imageUrl);
  };

  useEffect(() => {
    fetchDevices(searchQuery);
  }, [searchQuery]);

  const [visibleColumns, setVisibleColumns] = useState(
    JSON.parse(localStorage.getItem("visibleColumns")) || []
  );

  const handleFeatureEdit = (row) => {
    setModelRow({ ...row });
    setfeatureeditpopup(true);
  };

  const handleFeatureChange = (index, value) => {
    setModelRow((prevState) => {
      const updatedFeatures = prevState.features.map((feature, i) =>
        i === index ? { ...feature, feature_value: value } : feature
      );
      return { ...prevState, features: updatedFeatures };
    });
  };

  const handleSaveFeature = async () => {
    setLoading(true);
    setLoadingText("Updating features...");

    try {
      for (const feature of modelRow.features) {
        if (!feature.feature_id) continue;

        const response = await fetch(
          `${backendurl}/dashboard/api/model/features/update/${modelRow.price_id}/${feature.feature_id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`,
            },
            body: JSON.stringify({
              feature: feature.feature,
              feature_value: feature.feature_value,
            }),
          }
        );

        const data = await response.json();
        if (!response.ok) {
          showNotification("error", `Error updating ${feature.feature}: ${data.error}`, "Update Failed");
        }
      }

      showNotification("success", "Features updated successfully!");
      setfeatureeditpopup(false);
      fetchDevices();
    } catch (error) {
      console.error("Failed to update feature:", error);
      showNotification("error", "Failed to update feature", "Network Error");
    } finally {
      setLoading(false);
    }
  };

  const handleFeatureDelete = async (row) => {
    setModelRow(row);
    setfeaturedeletepopup(true);
  };

  const FeatureDelete = async (model_id, feature_id) => {
    if (!window.confirm("Are you sure you want to delete this feature?")) {
      return;
    }

    setLoading(true);
    setLoadingText("Deleting feature...");

    try {
      const response = await fetch(
        `${backendurl}/dashboard/api/model/features/delete/${model_id}/${feature_id}`,
        {
          method: "DELETE",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (response.ok) {
        showNotification("success", "Feature deleted successfully!");
        setModelRow((prevState) => ({
          ...prevState,
          features: prevState.features.filter((f) => f.feature_id !== feature_id),
        }));
        fetchDevices();
      } else {
        showNotification("error", `Error: ${data.error}`, "Delete Failed");
      }
    } catch (error) {
      console.error("Failed to delete feature:", error);
      showNotification("error", "Failed to delete feature", "Network Error");
    } finally {
      setLoading(false);
    }
  };

  const handleFeatureAdd = async (row) => {
    setModelRow(row);
    setfeatureaddpopup(true);
  };

  const AddFeature = async (modelId, feature, featureValue) => {
    if (!feature.trim() || !featureValue.trim()) {
      showNotification("warning", "Please fill in both feature name and value", "Missing Information");
      return;
    }

    setLoading(true);
    setLoadingText("Adding feature...");

    try {
      const response = await fetch(`${backendurl}/dashboard/api/model/features/add/${modelId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({
          feature: feature,
          feature_value: featureValue,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        showNotification("success", "Feature added successfully!");
        setfeatureaddpopup(false);
        fetchDevices();
      } else {
        showNotification("error", `Error: ${data.error}`, "Add Failed");
      }
    } catch (error) {
      console.error("Failed to add feature:", error);
      showNotification("error", "Failed to add feature", "Network Error");
    } finally {
      setLoading(false);
    }
  };

  const fetchUserData = async () => {
    try {
      const response = await fetch(`${backendurl}/api/display/user`, {
        method: "GET",
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        withCredentials: true,
        credentials: "include",
      });

      if (response.ok) {
        const data = await response.json();
        setUserData(data);
      } else {
        console.error("Failed to fetch user data.");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const handlerawDeleteClick = (row) => {
    setSelectedRawMaterial(row);
    setShowrawDeletePopup(true);
  };

  const handleClosePopup = () => {
    setShowrawDeletePopup(false);
  };

  const handlerawDeleteConfirm = async () => {
    if (!selectedRawMaterial) return;

    setLoading(true);
    setLoadingText("Deleting raw material...");

    try {
      const response = await fetch(`${backendurl}/dashboard/api/delete/thingrawmaterials/${selectedRawMaterial.id}`, {
        headers: {
          'Authorization': ` Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
      });

      const result = await response.json();

      if (response.ok) {
        setDeleteRawMaterials((prevMaterials) =>
          prevMaterials.filter((material) => material.id !== selectedRawMaterial.id)
        );
        setShowrawDeletePopup(false);
        showNotification("success", "Raw material deleted successfully!");
        fetchRawMaterials(modelId);
      } else {
        console.error('Error:', result.message);
        showNotification("error", result.message || "Failed to delete raw material", "Delete Failed");
      }
    } catch (error) {
      console.error('Error deleting raw material:', error);
      showNotification("error", "Error deleting raw material", "Network Error");
    } finally {
      setLoading(false);
    }
  };

  const [newModel, setNewModel] = useState({
    model: "",
    mrp: "",
    sgst: "",
    cgst: "",
    discount: "0",
    warranty_period: "",
  });

  const handleEditClick = (row) => {
    setActionPopup(true);
    setActionData(row);
  };

  const handleDeleteClick = (row) => {
    setDeletePopup(true);
    setDeleteData(row);
  };

  useEffect(() => {
    const savedColumns = localStorage.getItem("selectedColumns");
    if (savedColumns) {
      setSelectedColumns(JSON.parse(savedColumns));
    }
    fetchDevices();
  }, []);

  const fetchDevices = async (query = "") => {
    setIsFetching(true);
    setLoadingText("Loading devices...");

    try {
      const response = await fetch(
        `${backendurl}/dashboard/api/display/prices-table?search=${searchQuery}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          method: "GET",
        }
      );
      const data = await response.json();
      const formattedData = Array.isArray(data.data) ? data.data : [];
      setDevices(formattedData);
      generateDynamicColumns(formattedData);
    } catch (error) {
      console.error("Error fetching devices:", error);
      showNotification("error", "Failed to load devices", "Load Error");
    } finally {
      setIsFetching(false);
    }
  };

  const fetchRawMaterials = async (modelId) => {
    setLoading(true);
    setLoadingText("Loading raw materials...");

    try {
      const response = await fetch(`${backendurl}/dashboard/api/model/${modelId}`, {
        headers: {
          'Authorization': ` Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (response.ok) {
        setRawMaterials(data.raw_materials);
        setModelId(modelId);
        setEditPopup(true);
      } else {
        console.error("Error fetching raw materials:", data.error);
        showNotification("error", "Failed to load raw materials", "Load Error");
      }
    } catch (error) {
      console.error("Error fetching raw materials:", error);
      showNotification("error", "Error loading raw materials", "Network Error");
    } finally {
      setLoading(false);
    }
  };

  const handleSaveActionPopup = async () => {
    if (!editData) {
      showNotification("error", "No data to update", "Update Failed");
      return;
    }

    const { modelId, rawMaterialId } = editData;

    if (!Qty || Qty <= 0) {
      showNotification("warning", "Please provide a valid quantity greater than zero", "Validation Error");
      return;
    }

    setLoading(true);
    setLoadingText("Updating raw material...");

    try {
      const response = await fetch(`${backendurl}/dashboard/api/update/raw/${modelId}/${rawMaterialId}`, {
        method: "PUT",
        headers: {
          'Authorization': ` Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ requiredQty: Qty }),
      });

      if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(`Failed to update raw material: ${errorMessage}`);
      }

      const updatedMaterial = await response.json();
      fetchRawMaterials(modelId);
      setMaterials((prevMaterials) =>
        prevMaterials.map((material) =>
          material.rawMaterialId === updatedMaterial.data.raw_material_id &&
            material.modelId === updatedMaterial.data.model_id
            ? { ...material, required_qty: updatedMaterial.data.required_qty }
            : material
        )
      );

      handleCloseActionPopup();
      showNotification("success", "Raw material updated successfully!");
    } catch (error) {
      console.error("Error updating raw material:", error);
      showNotification("error", "Error updating raw material", "Update Failed");
    } finally {
      setLoading(false);
    }
  };

  const handleCloseActionPopup = () => {
    setActionPopup(false);
    setRequiredQty("");
  };

  useEffect(() => {
    const fetchComponents = async () => {
      setLoading(true);
      setLoadingText("Loading components...");

      try {
        const response = await fetch(`${backendurl}/dashboard/api/raw_materials`, {
          headers: {
            'Authorization': ` Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const data = await response.json();
        setComponents(data.raw_materials || []);
      } catch (error) {
        console.error("Error fetching components:", error);
        showNotification("error", "Failed to load components", "Load Error");
      } finally {
        setLoading(false);
      }
    };

    fetchComponents();
  }, []);

  const handleAddRawMaterial = async (modelid) => {
    if (!selectedComponent) {
      showNotification("warning", "Please select a component", "Missing Information");
      return;
    }

    if (!requiredQty || requiredQty <= 0) {
      showNotification("warning", "Please enter a valid quantity", "Validation Error");
      return;
    }

    setLoading(true);
    setLoadingText("Adding raw material...");

    try {
      const response = await fetch(`${backendurl}/dashboard/api/model/${modelid}/add-raw-material`, {
        method: "POST",
        headers: {
          'Authorization': ` Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          raw_material_id: selectedComponent,
          required_qty: requiredQty,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        showNotification("success", "Raw material added successfully!");
        fetchRawMaterials(modelId);
        setSelectedComponent("");
        setRequiredQty("");
      } else {
        const error = await response.json();
        showNotification("error", error.error || "Failed to add raw material", "Add Failed");
      }
    } catch (err) {
      console.error("Error adding raw material:", err);
      showNotification("error", "An error occurred while adding the raw material", "Network Error");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (row) => {
    setEditData(row);
    setShowPopup(true);
  };

  const handleEditPopup = (row) => {
    setEditData(row);
    setEditPopup(true);
  };

  const handleDeleteClickee = (row) => {
    setDeleteData(row);
    setDeletePopup(true);
  };

  const handlefeaturepopup = (row) => {
    fetchModelData(row.price_id);
    setEditData(row);
    setfeaturepopup(true);
  };

  const handleEditImagePopup = (row) => {
    setEditData(row);
    setEditImagePopup(true);
  };
  const handleRemoveNewImage = (index) => {
    setNewImages((prev) => prev.filter((_, i) => i !== index));
  };
  const handleFileChange = (event) => {
    // console.log("📂 File input triggered");

    const selectedFiles = Array.from(event.target.files);

    // console.log("🧾 Selected files:", selectedFiles);

    if (!selectedFiles.length) {
      console.warn("⚠️ No files selected");
      return;
    }

    // console.log("📊 Existing featureImages:", featureImages.length);
    // console.log("📊 Existing newImages:", newImages.length);
    // console.log("📊 Newly selected:", selectedFiles.length);

    const totalImages = featureImages.length + newImages.length + selectedFiles.length;

    // console.log("📊 Total after selection:", totalImages);

    if (totalImages > 6) {
      // console.warn("🚫 Upload limit exceeded");
      showNotification(
        "warning",
        "You can only upload 5 images total",
        "Upload Limit"
      );
      return;
    }

    // selectedFiles.forEach((file, index) => {
    //    console.log(`📸 File ${index}:`, {
    //     name: file.name,
    //     size: file.size,
    //     type: file.type,
    //   });
    // });

    setNewImages((prev) => {
      const updated = [...prev, ...selectedFiles];
      // console.log("✅ Updated newImages:", updated);
      return updated;
    });

    // optional: reset input so same file can be selected again
    // event.target.value = null;
  };
  const handleDeleteConfirm = async () => {
    setLoading(true);
    setLoadingText("Deleting device...");
    // console.log("deleting data ",deleteData)
    try {
      const response = await fetch(
        `${backendurl}/dashboard/api/delete/price_table/${deleteData.price_id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      // 🔹 Handle specific status codes
      if (response.status === 404) {
        showNotification(
          "warning",
          "Device not found or already deleted",
          "Not Found"
        );
        return;
      }

      if (response.status === 401 || response.status === 403) {
        showNotification(
          "error",
          "You are not authorized to delete this device",
          "Unauthorized"
        );
        return;
      }

      if (!response.ok) {
        throw new Error("Failed to delete device");
      }

      // ✅ Success
      setDevices(prev =>
        prev.filter(device => device.id !== deleteData.id)
      );
      setDeletePopup(false);

      showNotification(
        "success",
        "Device deleted successfully!"
      );

      fetchDevices();

    } catch (error) {
      console.error("Error deleting device:", error);

      showNotification(
        "error",
        error.message || "Error deleting device",
        "Delete Failed"
      );

    } finally {
      setLoading(false);
    }
  };


  const handleCloseDeletePopup = () => {
    setDeletePopup(false);
    setDeleteData(null);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const validateWarrantyPeriod = (warranty) => {
    const validFormat = /^(?:(\d+)\s+years?)?\s*(?:(\d+)\s+months?)?$/i;
    return validFormat.test(warranty);
  };

  const handleSaveEdit = async (priceid) => {
    const { id, mrp, retail_price, discount, sgst, cgst, igst, warranty_period } = editData;

    if (!validateWarrantyPeriod(warranty_period)) {
      showNotification("error", "Invalid warranty period format. Use formats like '2 years', '6 months', or '1 year 6 months'", "Validation Error");
      return;
    }

    if (!sgst || !cgst || !igst) {
      showNotification("warning", "Please provide valid tax values", "Missing Information");
      return;
    }

    setLoading(true);
    setLoadingText("Updating device...");

    try {
      const response = await fetch(`${backendurl}/dashboard/api/update/price_table/${priceid}`, {
        method: "PUT",
        headers: {
          'Authorization': ` Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ mrp, retail_price, discount, sgst, cgst, igst, warranty_period }),
      });

      if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(`Failed to update device: ${errorMessage}`);
      }

      const updatedDevice = await response.json();
      setDevices((prevDevices) =>
        prevDevices.map((device) => (device.id === updatedDevice.id ? updatedDevice : device))
      );
      setShowPopup(false);
      setEditData(null);
      showNotification("success", "Device updated successfully!");
      fetchDevices();
    } catch (error) {
      console.error("Error updating device:", error);
      showNotification("error", "Error updating device", "Update Failed");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchImages = async () => {
      if (!modelId) return;

      setLoading(true);
      setLoadingText("Loading images...");

      try {
        const response = await fetch(`${backendurl}/dashboard/api/display/model/features/${modelId}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();
          setImages(data.images || []);
        } else {
          console.error("Failed to fetch images");
        }
      } catch (error) {
        console.error("Error fetching images:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, [modelId]);

  const handleUploadimg = async (modelId) => {
    console.log("🚀 Upload started");

    if (!newImages.length) {
      console.warn("⚠️ No images selected");
      showNotification("warning", "Please select images to upload", "No Images Selected");
      return;
    }

    console.log("📦 Images to upload:", newImages);

    setIsUploading(true);
    setLoadingText("Uploading images...");

    const formData = new FormData();

    newImages.forEach((image, index) => {
      console.log(`📸 Appending image ${index}:`, image.name, image.size);
      formData.append("images", image);
    });

    // 🔍 Log FormData contents
    for (let pair of formData.entries()) {
      console.log("🧾 FormData:", pair[0], pair[1]);
    }

    try {
      console.log("🌐 Sending request to:", `${backendurl}/dashboard/api/upload-images/${modelId}`);

      const response = await fetch(`${backendurl}/dashboard/api/upload-images/${modelId}`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("📡 Response status:", response.status);

      // ⚠️ IMPORTANT: read as text first
      const responseText = await response.text();
      console.log("📨 Raw response:", responseText);

      let data;
      try {
        data = JSON.parse(responseText);
      } catch (err) {
        console.error("❌ JSON parse failed. Response is not JSON.");
        throw new Error("Invalid JSON response from server");
      }

      if (response.ok) {
        console.log("✅ Upload success:", data);

        const newFeatureImages = data.imagePaths.map((imageUrl, index) => ({
          id: Date.now() + index,
          images: [{ image_id: Date.now() + index, image_url: imageUrl }],
        }));

        setFeatureImages((prev) => [...prev, ...newFeatureImages]);
        setNewImages([]);
        setEditImagePopup(false);

        showNotification("success", "Images uploaded successfully!");
        fetchModelData(modelId);
      } else {
        console.error("❌ Upload failed:", data);
        showNotification("error", data.message || "Failed to upload images", "Upload Failed");
      }
    } catch (error) {
      console.error("🔥 Error uploading images:", error);
      showNotification("error", "Error uploading images", "Network Error");
    } finally {
      console.log("🏁 Upload finished");
      setIsUploading(false);
    }
  };

  const handleDeleteImage = async (imageid) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this image?");
    if (!confirmDelete) return;

    setLoading(true);
    setLoadingText("Deleting image...");

    try {
      const response = await fetch(`${backendurl}/dashboard/api/delete-image/${imageid}`, {
        method: "DELETE",
        headers: {
          'Authorization': ` Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        setImages((prevImages) => prevImages.filter((image) => image.modelId !== modelId));
        showNotification("success", "Image deleted successfully!");
      } else {
        const data = await response.json();
        showNotification("error", data.message || "Failed to delete the image", "Delete Failed");
      }
    } catch (error) {
      console.error("Error deleting image:", error);
      showNotification("error", "An error occurred while deleting the image", "Network Error");
    } finally {
      setLoading(false);
    }
  };

  const handleAddNewModel = async () => {
    if (!newModel.model.trim()) {
      showNotification("warning", "Please enter model name", "Missing Information");
      return;
    }

    if (!newModel.mrp || newModel.mrp <= 0) {
      showNotification("warning", "Please enter a valid MRP", "Validation Error");
      return;
    }

    setLoading(true);
    setLoadingText("Adding new model...");

    try {
      const response = await fetch(`${backendurl}/dashboard/api/create/price_table`, {
        method: "POST",
        headers: {
          'Authorization': ` Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newModel),
      });

      if (!response.ok) {
        throw new Error("Failed to add new model");
      }

      const addedDevice = await response.json();
      setDevices([...devices, addedDevice]);
      setAddPopup(false);
      setNewModel({
        model: "",
        mrp: "",
        retail_price: "",
        sgst: "",
        cgst: "",
        igst: "",
        discount: "0",
        warranty_period: "",
      });
      showNotification("success", "New model added successfully!");
      fetchDevices();
    } catch (error) {
      console.error("Error adding new model:", error);
      showNotification("error", "Error adding new model", "Add Failed");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const storedRole = localStorage.getItem('userRole');
    setUserRole(storedRole);
  }, []);

  if (userData.userrole === "customer") {
    return null;
  }

  const generateDynamicColumns = (data) => {
    let featureColumns = new Set();
    let attributeColumns = new Set();

    data.forEach((device) => {
      device.features?.forEach((feature) => featureColumns.add(feature.feature));
      device.attributes?.forEach((attribute) => attributeColumns.add(attribute.attributeName));
    });

    const staticColumns = [
      { id: "id", name: "ID", selector: (row, index) => index + 1, sortable: true },
      { id: "model", name: "Model", selector: (row) => row.model, sortable: true },
      { id: "mrp", name: "MRP", selector: (row) => row.mrp, sortable: true },
      { id: "sgst", name: "SGST", selector: (row) => row.sgst, sortable: true },
      { id: "cgst", name: "CGST", selector: (row) => row.cgst, sortable: true },
      { id: "discount", name: "Discount", selector: (row) => row.discount, sortable: true },
      {
        id: "lastmodified_date",
        name: "Date",
        selector: (row) => row.lastmodified ? row.lastmodified.split("T")[0] : "-",
        sortable: true,
      },
      {
        id: "lastmodified_time",
        name: "Time",
        selector: (row) => row.lastmodified ? row.lastmodified.split("T")[1]?.split(".")[0] || "-" : "-",
        sortable: true,
      }
    ];

    const dynamicFeatureColumns = Array.from(featureColumns)
      .filter((feature) => feature !== null && feature !== undefined)
      .map((feature, index) => ({
        id: `feature_${index}`,
        name: feature,
        selector: (row) =>
          row.features?.find((f) => f.feature === feature)?.feature_value || "-",
        sortable: true,
      }));

    const dynamicAttributeColumns = Array.from(attributeColumns)
      .filter((attribute) => attribute !== null && attribute !== undefined)
      .map((attribute, index) => ({
        id: `attribute_${index}`,
        name: attribute,
        selector: (row) =>
          row.attributes?.find((attr) => attr.attributeName === attribute)?.attributeValue || "-",
        sortable: true,
      }));

    const actionColumn = {
      id: "images",
      name: "Images",
      cell: (row) => (
        <button className="raw-button" onClick={() => handlefeaturepopup(row)}>
          <i className="fa-solid fa-image"></i>
        </button>
      ),
    };

    let finalColumns = [...staticColumns, ...dynamicFeatureColumns, ...dynamicAttributeColumns, actionColumn];
    // userData.userrole === "admin"
    if (true) {
      const adminColumns = [
        {
          id: "raw materials",
          name: "Raw Materials",
          cell: (row) => (
            <button className="raw-button" onClick={() => fetchRawMaterials(row.price_id)}>
              <i className="fa-solid fa-screwdriver-wrench"></i>
            </button>
          ),
        },
        {
          id: "action",
          name: "Price Edit",
          cell: (row) => (
            <div className="device-action-btn">
              <button className="action-button" onClick={() => handleEdit(row)}>
                <i className="fa-solid fa-pen-to-square"></i>
              </button>
              <button className="action-button" onClick={() => handleDeleteClick(row)}>
                <i className="fa-solid fa-trash-can"></i>
              </button>
            </div>
          ),
        },
      ];
      finalColumns = [...finalColumns, ...adminColumns];
    }

    const featureEdit = [
      {
        id: "feature",
        name: "feature",
        cell: (row) => (
          <div className="device-action-btn">
            <button className="action-button" >
              <i className="fa-solid fa-pen-to-square" onClick={() => handleFeatureEdit(row)}></i>
            </button>
            <button className="action-button" >
              <i className="fa-solid fa-trash-can" onClick={() => handleFeatureDelete(row)}></i>
            </button>
            <button className="action-button">
              <i className="fa-solid fa-circle-plus" onClick={() => handleFeatureAdd(row)}></i>
            </button>
            <button
              className="action-button"
              onClick={() => {
                // console.log("Row Data:", row);
                // console.log("Row ID:", row.id);

                openDescPopup(row.price_id);
              }}
            >
              <i className="fa-solid fa-file-lines"></i>
            </button>

          </div>
        ),
      }
    ];

    finalColumns = [...finalColumns, ...featureEdit];

    const storedColumns = JSON.parse(localStorage.getItem("visibleColumns"));
    if (storedColumns) {
      setVisibleColumns(storedColumns);
    } else {
      setVisibleColumns(finalColumns);
    }

    setColumns(finalColumns);
  };

  const toggleColumn = (columnId) => {
    setVisibleColumns((prevVisibleColumns) => {
      const columnExists = prevVisibleColumns.some((col) => col.id === columnId);
      let updatedColumns;

      if (columnExists) {
        updatedColumns = prevVisibleColumns.filter((col) => col.id !== columnId);
      } else {
        const columnToAdd = columns.find((col) => col.id === columnId);
        updatedColumns = columnToAdd ? [...prevVisibleColumns, columnToAdd] : prevVisibleColumns;
      }

      localStorage.setItem("visibleColumns", JSON.stringify(updatedColumns));
      return updatedColumns;
    });
  };

  const handlecheckSaveEdit = () => {
    setColumns(selectedColumns);
    setCheckPopup(false);
  };

  return (
    <div className={`device-main ${theme}-theme`}>
      {/* Show fullscreen loading spinner */}
      {/* {(loading || isFetching) && (
        // <LoadingSpinner 
        //   fullScreen={true} 
        //   text={loadingText}
        //   color={theme === "dark" ? "primary" : "primary"}
        // />
      )} */}

      {/* Show notification popup */}
      <NotificationPopup
        show={notification.show}
        type={notification.type}
        message={notification.message}
        title={notification.title}
        onClose={() => setNotification({ ...notification, show: false })}
        duration={5000}
      />

      <div className="dash-dummy"></div>
      <div className="second-main">
        <div className="device-content-main">
          <div className="device-content">
            <div className="device-content-head">
              <p>Device Details</p>
            </div>
            <div className="device-content-items">
              <div className="device-search">
                <i className="fa-solid fa-magnifying-glass"></i>
                <input
                  type="search"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={handleSearchChange}
                  disabled={isFetching}
                />
                {isFetching && (
                  <div style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                    {/* <LoadingSpinner size="small" color="primary" /> */}
                  </div>
                )}
              </div>
              {userData.userrole === "admin" && (
                <>
                  <i
                    className="fa-regular fa-square-plus add-model-icon"
                    onClick={() => setAddPopup(true)}
                    disabled={isFetching}
                    style={{ cursor: isFetching ? 'not-allowed' : 'pointer', opacity: isFetching ? 0.6 : 1 }}
                  ></i>
                </>
              )}
            </div>

            {checkpopup && (
              <div className="model-edit-popup-overlay">
                <div className="check-popup-column-content">
                  <button className="model-edit-popup-close" type="button" onClick={() => setCheckPopup(false)} >
                    <i className="fa-solid fa-x"></i>
                  </button>
                  <div className="check-popup-column-list">
                    <ul>
                      {columns.map((col) => (
                        <li key={col.id}>
                          <input
                            type="checkbox"
                            checked={visibleColumns.some((vc) => vc.id === col.id)}
                            onChange={() => toggleColumn(col.id)}
                          />
                          {col.name}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {showPopup && (
              <div className="model-edit-popup-overlay">
                <div className="model-edit-popup-content">
                  <button
                    className="model-edit-popup-close"
                    type="button"
                    onClick={() => setShowPopup(false)}
                  >
                    <i className="fa-solid fa-x"></i>
                  </button>
                  <form className="model-edit-popup-input">
                    <div>
                      <label>MRP:</label> <br />
                      <input
                        type="number"
                        min={0}
                        value={editData?.mrp || ""}
                        onChange={(e) => setEditData({ ...editData, mrp: e.target.value })}
                        disabled={loading}
                      />
                    </div>
                    <div>
                      <label>Discount:</label> <br />
                      <input
                        type="number"
                        min={0}
                        value={editData?.discount || ""}
                        onChange={(e) => setEditData({ ...editData, discount: e.target.value })}
                        disabled={loading}
                      />
                    </div>
                    <div className="model-add-input-tax">
                      <div className="sgst tax">
                        <label>SGST:</label>
                        <input
                          type="number"
                          min={0}
                          value={editData?.sgst || ""}
                          onChange={(e) => setEditData({ ...editData, sgst: e.target.value })}
                          disabled={loading}
                        />
                      </div>
                      <div className="cgst tax">
                        <label>CGST:</label>
                        <input
                          type="number"
                          min={0}
                          value={editData?.cgst || ""}
                          onChange={(e) => setEditData({ ...editData, cgst: e.target.value })}
                          disabled={loading}
                        />
                      </div>
                    </div>
                    <div>
                      <label>Warranty:</label> <br />
                      <input
                        type="text"
                        value={
                          editData?.warranty_period &&
                            (editData.warranty_period.years || editData.warranty_period.months)
                            ? `${editData.warranty_period.years ? editData.warranty_period.years + " year" + (editData.warranty_period.years > 1 ? "s" : "") : ""} 
                               ${editData.warranty_period.months ? editData.warranty_period.months + " month" + (editData.warranty_period.months > 1 ? "s" : "") : ""}`.trim()
                            : editData.warranty_period || " "
                        }
                        onChange={(e) => setEditData({ ...editData, warranty_period: e.target.value })}
                        disabled={loading}
                      />
                    </div>
                  </form>
                  <button
                    type="button"
                    className="model-edit-popup-save"
                    onClick={() => handleSaveEdit(editData.price_id)}
                    disabled={loading}
                  >
                    {loading ? <LoadingSpinner size="small" text="" /> : "Save"}
                  </button>
                </div>
              </div>
            )}
          </div>

          {isFetching ? (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '300px',
              width: '100%',
              background: theme === 'dark' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(255, 255, 255, 0.8)',
              borderRadius: '8px',
              marginTop: '20px'
            }}>
              <LoadingSpinner size="medium" text="Loading device data..." color="primary" />
            </div>
          ) : (
            <DataTable
              columns={columns}
              data={devices}
              fixedHeader
              pagination
              progressPending={isFetching}
              progressComponent={<div style={{ padding: '20px' }}><LoadingSpinner size="medium" text="Loading..." color="primary" /></div>}
            />
          )}

          {featureeditpopup && (
            <div className="feature-edit-popup-overlay">
              <div className="model-feature-edit-popup-content">
                <button className="raw-popup-close" onClick={() => setfeatureeditpopup(false)} disabled={loading}>
                  <i className="fa-solid fa-x"></i>
                </button>
                <h3>Edit Features</h3>
                <div className="feature-edit-popup-input-main">
                  {modelRow.features.map((feature, index) => (
                    <div key={feature.feature_id || index}>
                      <label>{feature.feature}:</label>
                      <br />
                      <input
                        type="text"
                        value={feature.feature_value || ""}
                        onChange={(e) => handleFeatureChange(index, e.target.value)}
                        disabled={loading}
                      />
                    </div>
                  ))}
                </div>
                <button className="feature-save-btn" onClick={handleSaveFeature} disabled={loading}>
                  {loading ? <LoadingSpinner size="small" text="" color="primary" /> : "Save"}
                </button>
              </div>
            </div>
          )}

          {featuredeletepopup && (
            <div className="feature-edit-popup-overlay">
              <div className="model-feature-edit-popup-content">
                <button
                  className="model-popup-close"
                  onClick={() => setfeaturedeletepopup(false)}
                  disabled={loading}
                >
                  <i className="fa-solid fa-x"></i>
                </button>

                <div className="model-feature-delete-popup-list-main">
                  <ul>
                    {modelRow?.features?.map((feature, index) => {
                      return (
                        <li key={feature.feature_id || index}>
                          {feature.feature} - {feature.feature_value || "N/A"}
                          <i
                            className="fa-solid fa-trash-can"
                            onClick={() => FeatureDelete(modelRow.price_id, feature.feature_id)}
                            style={{ cursor: "pointer", marginLeft: "10px", color: "red", opacity: loading ? 0.6 : 1 }}
                            disabled={loading}
                          ></i>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          )}

          {featureaddpopup && (
            <div className="feature-edit-popup-overlay">
              <div className="model-feature-Add-popup-content">
                <button
                  className="model-popup-close"
                  onClick={() => setfeatureaddpopup(false)}
                  disabled={loading}
                >
                  <i className="fa-solid fa-x"></i>
                </button>
                <h3>Add Features</h3>
                <div className="model-feature-add-popup-input">
                  <input
                    type="text"
                    placeholder="Feature Name"
                    value={feature}
                    onChange={(e) => setFeature(e.target.value)}
                    disabled={loading}
                  />
                  <input
                    type="text"
                    placeholder="Feature Value"
                    value={featureValue}
                    onChange={(e) => setFeatureValue(e.target.value)}
                    disabled={loading}
                  />
                </div>
                <button className="add-save-btn" onClick={() => AddFeature(modelRow.price_id, feature, featureValue)} disabled={loading}>
                  {loading ? <LoadingSpinner size="small" text="" color="primary" /> : "Add Feature"}
                </button>
              </div>
            </div>
          )}

          {featurepopup && (
            <div className="feature-popup-overlay">
              <div className="feature-popup-content-main">
                <button className="model-popup-close" onClick={() => setfeaturepopup(false)}>
                  <i className="fa-solid fa-x"></i>
                </button>

                <div className="feature-popup-content">
                  <div className="feature-popup-image-main">
                    <div className="feature-popup-image">
                      {mainImage ? (
                        <img src={mainImage} alt="Main" />
                      ) : (
                        <p>No Feature Images</p>
                      )}
                    </div>
                    <div className="feature-popup-subimg-main">
                      {featureImages.length > 0 ? (
                        featureImages.map((img, index) => (
                          <img
                            key={index}
                            src={`${backendurl}${img.images[0].image_url}`}
                            alt={`Feature ${index + 1}`}
                            onClick={() => handleImageClick(`${backendurl}${img.images[0].image_url}`)}
                            style={{
                              cursor: "pointer",
                              border: mainImage === `${backendurl}${img.images[0].image_url}` ? "1px solid var(--text-color)" : "none",
                            }}
                          />
                        ))
                      ) : (
                        <p>No Sub Images</p>
                      )}
                    </div>
                    <div className="Edit-Feature-Image">
                      <button className="" onClick={handleEditImagePopup} disabled={isUploading}>
                        {isUploading ? <LoadingSpinner size="small" text="" color="primary" /> : "Edit Feature Image"}
                      </button>
                    </div>
                  </div>

                  <div className="feature-popup-web-image">
                    <div className="feature-popup-list-main">
                      {webImages.length > 0 ? (
                        webImages.map((img, index) => (
                          <img
                            key={index}
                            src={`${backendurl}${img.images[0].image_url}`}
                            alt={`Web ${index + 1}`}
                          />
                        ))
                      ) : (
                        <p>No Web Images</p>
                      )}

                    </div>
                    <div className="Edit-Feature-Image">
                      <button className="" onClick={handleEditFeaturePopup} disabled={isUploading}>
                        {isUploading ? <LoadingSpinner size="small" text="" color="primary" /> : "Edit Web Image"}
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          )}

          {editImagePopup && (
            <div className="edit-image-popup-overlay">
              <div className="edit-image-popup-content">
                <button className="model-popup-close" onClick={() => setEditImagePopup(false)}>
                  <i className="fa-solid fa-x"></i>
                </button>

                <h3>Upload New Image</h3>

                <div className="model-edit-img-input-main">

                  {/* ✅ Already uploaded images */}
                  {featureImages.map((img, index) => (
                    <div className="model-edit-img-input" key={`old-${index}`}>
                      <img src={`${backendurl}${img.images[0].image_url}`} alt={`Image ${index + 1}`} />
                      <div
                        className="model-delete-img-btn"
                        onClick={() => handleDeleteImage(img.images[0].image_id)}
                        style={{ cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.6 : 1 }}
                      >
                        <i className="fa-solid fa-trash"></i>
                      </div>
                    </div>
                  ))}

                  {/* ✅ NEW: Preview images before upload */}
                  {newImages.map((file, index) => (
                    <div className="model-edit-img-input" key={`new-${index}`}>
                      <img src={URL.createObjectURL(file)} alt={`New ${index}`} />

                      {/* ❌ Remove before upload */}
                      <div
                        className="model-delete-img-btn"
                        onClick={() => handleRemoveNewImage(index)}
                      >
                        <i className="fa-solid fa-x"></i>
                      </div>
                    </div>
                  ))}

                </div>

                <div className="model-featur-edit-img-btn">
                  <label htmlFor="add-img"></label>
                  <input
                    type="file"
                    id="add-img"
                    style={{ display: "none" }}
                    accept="image/jpeg, image/png, image/gif"
                    multiple
                    onChange={handleFileChange}
                    disabled={isUploading}
                  />
                  <div className="model-change-img-btn" onClick={() => !isUploading && document.getElementById("add-img").click()}>
                    <p>{isUploading ? <LoadingSpinner size="small" text="" color="primary" /> : "Upload Photo"}</p>
                  </div>
                </div>

                <div className="edit-image-popup-buttons">
                  <button onClick={() => handleUploadimg(modelId)} disabled={isUploading}>
                    {isUploading ? <LoadingSpinner size="small" text="" color="primary" /> : "Save"}
                  </button>

                </div>
              </div>
            </div>
          )}

          {editFeaturePopup && (
            <div className="edit-image-popup-overlay">
              <div className="edit-image-popup-content">
                <button
                  className="model-popup-close"
                  onClick={() => setEditFeaturePopup(false)}
                >
                  <i className="fa-solid fa-x"></i>
                </button>

                <h3>Upload New Feature</h3>

                <div className="model-edit-img-input-main">
                  {webImages.map((img, index) => (
                    <div className="model-edit-img-input" key={index}>
                      <img src={`${backendurl}${img.images[0].image_url}`} alt={`Image ${index + 1}`} />
                      <div className="model-delete-img-btn" onClick={() => handleDeletewebImage(img.images[0].image_id)} style={{ cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.6 : 1 }}>
                        <i className="fa-solid fa-trash"></i>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="model-featur-edit-img-btn">
                  <label htmlFor="add-img"></label>
                  <input
                    type="file"
                    id="add-img"
                    style={{ display: "none" }}
                    accept="image/*"
                    multiple
                    onChange={handlewebFileChange}
                    disabled={isUploading}
                  />
                  <div className="model-change-img-btn" onClick={() => !isUploading && document.getElementById("add-img").click()}>
                    <p>{isUploading ? <LoadingSpinner size="small" text="" color="primary" /> : "Upload Photo"}</p>
                  </div>
                </div>

                <div className="edit-image-popup-buttons">
                  <button onClick={() => handleUploadwebimg(modelId)} disabled={isUploading}>
                    {isUploading ? <LoadingSpinner size="small" text="" color="primary" /> : "Save"}
                  </button>
                </div>
              </div>
            </div>
          )}

          {deletePopup && (
            <div className="delete-popup-overlay">
              <div className="delete-popup-content">
                <p>Are you sure you want to delete this device?</p>
                <div className="delete-popup-btn">
                  <button className="delete-popup-confirm" onClick={handleDeleteConfirm} disabled={loading}>
                    {loading ? <LoadingSpinner size="small" text="" color="primary" /> : "Confirm"}
                  </button>
                  <button className="delete-popup-cancel" onClick={handleCloseDeletePopup} disabled={loading}>
                    Cancel
                  </button>
                </div>

              </div>
            </div>
          )}

          {addPopup && (
            <div className="model-popup-overlay">
              <div className="model-popup-content">
                <button className="model-popup-close" onClick={() => setAddPopup(false)}>
                  <i className="fa-solid fa-x"></i>
                </button>
                <h3>Add New Model</h3>
                <form>
                  <div className="model-add-input">
                    <label>Model :</label>
                    <input
                      type="text"
                      value={newModel.model}
                      onChange={(e) => setNewModel({ ...newModel, model: e.target.value })}
                      disabled={loading}
                    />
                  </div>

                  <div className="model-add-input">
                    <label>MRP :</label>
                    <input
                      type="number"
                      min={0}
                      value={newModel.mrp}
                      onChange={(e) => setNewModel({ ...newModel, mrp: e.target.value })}
                      disabled={loading}
                    />
                  </div>

                  <div className="model-add-input">
                    <label>SGST(%):</label>
                    <input
                      type="number"
                      min={0}
                      value={newModel.sgst}
                      onChange={(e) => setNewModel({ ...newModel, sgst: e.target.value })}
                      disabled={loading}
                    />
                  </div>
                  <div className="model-add-input">
                    <label>CGST(%):</label>
                    <input
                      type="number"
                      min={0}
                      value={newModel.cgst}
                      onChange={(e) => setNewModel({ ...newModel, cgst: e.target.value })}
                      disabled={loading}
                    />
                  </div>

                  <div className="model-add-input">
                    <label>Discount(%) :</label>
                    <input
                      type="number"
                      min={0}
                      value={newModel.discount}
                      onChange={(e) => setNewModel({ ...newModel, discount: e.target.value })}
                      disabled={loading}
                    />
                  </div>

                  <div className="model-add-input">
                    <label>Warranty Period :</label>
                    <input
                      type="text"
                      placeholder="e.g., 6 months, 1 year"
                      value={newModel.warranty_period}
                      onChange={(e) => setNewModel({ ...newModel, warranty_period: e.target.value })}
                      disabled={loading}
                    />
                  </div>

                </form>
                <button className="model-popup-save" onClick={handleAddNewModel} disabled={loading}>
                  {loading ? <LoadingSpinner size="small" text="" color="primary" /> : "Save"}
                </button>
              </div>
            </div>
          )}
          {descPopup && (
            <div className="model-edit-popup-overlay">
              <div className="model-desc-edit-popup-content">

                <button
                  className="model-edit-popup-close"
                  onClick={() => setDescPopup(false)}
                  disabled={isDescLoading}
                >
                  ✕
                </button>

                <h3>Product Description</h3>

                <div className="model-edit-popup-input">

                  {/* 2 COLUMN */}
                  <div className="desc-grid">

                    <input
                      placeholder="Title"
                      value={descData.title || ""}
                      onChange={(e) =>
                        setDescData({ ...descData, title: e.target.value })
                      }
                      disabled={isDescLoading}
                    />

                    <input
                      placeholder="Short Description"
                      value={descData.short_description || ""}
                      onChange={(e) =>
                        setDescData({ ...descData, short_description: e.target.value })
                      }
                      disabled={isDescLoading}
                    />

                    <input
                      placeholder="Category"
                      value={descData.category || ""}
                      onChange={(e) =>
                        setDescData({ ...descData, category: e.target.value })
                      }
                      disabled={isDescLoading}
                    />

                    <input
                      placeholder="Type"
                      value={descData.type || ""}
                      onChange={(e) =>
                        setDescData({ ...descData, type: e.target.value })
                      }
                      disabled={isDescLoading}
                    />

                  </div>

                  {/* DESCRIPTION */}
                  <textarea
                    placeholder="Full Description"
                    value={descData.description || ""}
                    onChange={(e) =>
                      setDescData({ ...descData, description: e.target.value })
                    }
                    disabled={isDescLoading}
                  />

                  {/* SPECIFICATIONS */}
                  <div>
                    <h4>Specifications</h4>

                    {descData.specifications.map((spec, index) => (
                      <div key={index} className="spec-row">
                        <input
                          placeholder="Key"
                          value={spec.key}
                          onChange={(e) => {
                            const updated = [...descData.specifications];
                            updated[index].key = e.target.value;
                            setDescData({ ...descData, specifications: updated });
                          }}
                          disabled={isDescLoading}
                        />

                        <input
                          placeholder="Value"
                          value={spec.value}
                          onChange={(e) => {
                            const updated = [...descData.specifications];
                            updated[index].value = e.target.value;
                            setDescData({ ...descData, specifications: updated });
                          }}
                          disabled={isDescLoading}
                        />

                        <button
                          onClick={() => {
                            const updated = descData.specifications.filter((_, i) => i !== index);
                            setDescData({ ...descData, specifications: updated });
                          }}
                          disabled={isDescLoading}
                        >
                          ✕
                        </button>
                      </div>
                    ))}

                    <button
                      onClick={() =>
                        setDescData({
                          ...descData,
                          specifications: [...descData.specifications, { key: "", value: "" }]
                        })
                      }
                      disabled={isDescLoading}
                    >
                      + Add Spec
                    </button>
                  </div>

                  {/* FEATURES */}
                  <div>
                    <h4>Features</h4>

                    {descData.features.map((feature, index) => (
                      <div key={index} className="feature-row">
                        <input
                          placeholder="Feature"
                          value={feature}
                          onChange={(e) => {
                            const updated = [...descData.features];
                            updated[index] = e.target.value;
                            setDescData({ ...descData, features: updated });
                          }}
                          disabled={isDescLoading}
                        />

                        <button
                          onClick={() => {
                            const updated = descData.features.filter((_, i) => i !== index);
                            setDescData({ ...descData, features: updated });
                          }}
                          disabled={isDescLoading}
                        >
                          ✕
                        </button>
                      </div>
                    ))}

                    <button
                      onClick={() =>
                        setDescData({
                          ...descData,
                          features: [...descData.features, ""]
                        })
                      }
                      disabled={isDescLoading}
                    >
                      + Add Feature
                    </button>
                  </div>

                </div>

                {/* ACTIONS */}
                <div className="popup-actions">

                  {hasDescription && (
                    <button
                      className="delete-popup-confirm"
                      onClick={async () => {
                        if (!window.confirm("Are you sure you want to delete this description?")) {
                          return;
                        }

                        setIsDescLoading(true);
                        setLoadingText("Deleting description...");

                        try {
                          const response = await fetch(`${backendurl}/dashboard/api/product/description/${descData.product_id}`, {
                            method: "DELETE",
                            headers: {
                              'Authorization': `Bearer ${token}`,
                              'Content-Type': 'application/json',
                            },
                          });

                          if (response.ok) {
                            showNotification("success", "Description deleted successfully!");
                            setDescPopup(false);
                            fetchDevices(); // Refresh the list
                          } else {
                            const error = await response.json();
                            showNotification("error", error.message || "Failed to delete description", "Delete Failed");
                          }
                        } catch (error) {
                          console.error("Error deleting description:", error);
                          showNotification("error", "Error deleting description", "Network Error");
                        } finally {
                          setIsDescLoading(false);
                        }
                      }}
                      disabled={isDescLoading}
                    >
                      {isDescLoading ? <LoadingSpinner size="small" text="" color="danger" /> : "Delete"}
                    </button>
                  )}

                  <button
                    className="model-edit-popup-save"
                    disabled={(hasDescription && !isEditing) || isDescLoading}
                    onClick={async () => {
                      // convert specs to object
                      const specObject = {};
                      descData.specifications.forEach(s => {
                        if (s.key) specObject[s.key] = s.value;
                      });

                      const payload = {
                        ...descData,
                        specifications: specObject,
                        features: descData.features.filter(f => f)
                      };

                      setIsDescLoading(true);
                      setLoadingText(hasDescription ? "Updating description..." : "Saving description...");

                      try {
                        let response;
                        if (!hasDescription) {
                          response = await fetch(`${backendurl}/dashboard/api/product/add-description`, {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                              'Authorization': `Bearer ${token}`,
                            },
                            body: JSON.stringify(payload),
                          });
                        } else {
                          response = await fetch(`${backendurl}/dashboard/api/product/description/${descData.product_id}`, {
                            method: "PUT",
                            headers: {
                              "Content-Type": "application/json",
                              'Authorization': `Bearer ${token}`,
                            },
                            body: JSON.stringify(payload),
                          });
                        }

                        if (response.ok) {
                          showNotification(
                            "success",
                            hasDescription ? "Description updated successfully!" : "Description saved successfully!"
                          );
                          setDescPopup(false);
                          fetchDevices(); // Refresh the list
                        } else {
                          const error = await response.json();
                          showNotification("error", error.message || "Operation failed", "Error");
                        }
                      } catch (error) {
                        console.error("Error saving description:", error);
                        showNotification("error", "Error saving description", "Network Error");
                      } finally {
                        setIsDescLoading(false);
                      }
                    }}
                  >
                    {isDescLoading ? (
                      <LoadingSpinner size="small" text="" color="primary" />
                    ) : (
                      !hasDescription ? "Save" : "Save Changes"
                    )}
                  </button>

                </div>

              </div>
            </div>
          )}
          {editPopup && (
            <div className="model-edit-popup-overlay">
              <div className="model-row-edit-popup-content">
                <button
                  className="model-edit-popup-close"
                  type="button"
                  onClick={() => setEditPopup(false)}
                >
                  <i className="fa-solid fa-x"></i>
                </button>
                <div className="model-raw-details-main">
                  <DataTable
                    columns={[
                      {
                        name: 'ID',
                        selector: (row, index) => index + 1, sortable: true
                      },
                      {
                        name: "Image",
                        selector: (row) => row.image,
                        cell: (row) => (
                          <img
                            src={row.image}
                            alt={row.name || "Raw Material"}
                            style={{
                              width: "40px",
                              height: "40px",
                              objectFit: "cover",
                              borderRadius: "5px",
                            }}
                          />
                        ),
                        sortable: false,
                      },
                      { name: "Component", selector: (row) => row.component, sortable: true },
                      { name: "Required Quantity", selector: (row) => row.required_qty, sortable: true },
                      {
                        name: "Action",
                        cell: (row) => (

                          <div className="device-action-btn">
                            <button className="action-button" onClick={() => {
                              const { model_id, id } = row;
                              setEditData({ modelId: model_id, rawMaterialId: id });
                              setActionPopup(true);
                            }} disabled={loading}>
                              {loading ? <LoadingSpinner size="small" text="" color="primary" /> : <i className="fa-solid fa-pen-to-square"></i>}
                            </button>
                            <button className="action-button" onClick={() => handlerawDeleteClick(row)} disabled={loading}>
                              {loading ? <LoadingSpinner size="small" text="" color="primary" /> : <i className="fa-solid fa-trash-can"></i>}
                            </button>
                          </div>
                        ),
                      },
                    ]}
                    data={rawMaterials}
                    fixedHeader
                  />
                </div>
                <div className="model-raw-add-main">
                  <div className="model-raw-add-head">
                    <p>Add Raw Material</p>
                  </div>
                  <div className="model-raw-inputs">
                    <select
                      className="model-popup-select"
                      value={selectedComponent}
                      onChange={(e) => setSelectedComponent(e.target.value)}
                      disabled={loading}
                    >
                      <option value="" disabled>
                        Select Component
                      </option>
                      {components.map((data) => (
                        <option key={data.id} value={data.id}>
                          {data.category}
                        </option>
                      ))}
                    </select>

                    <input
                      type="number"
                      min={0}
                      placeholder="Required Qty"
                      value={requiredQty}
                      onChange={(e) => setRequiredQty(e.target.value)}
                      disabled={loading}
                    />
                    <button onClick={() => handleAddRawMaterial(modelId)} disabled={loading}>
                      {loading ? <LoadingSpinner size="small" text="" color="primary" /> : "ADD"}
                    </button>
                  </div>
                </div>

              </div>
            </div>
          )}
          {actionPopup && (
            <div className="action-popup-overlay">
              <div className="action-popup-content">
                <button
                  className="action-popup-close"
                  type="button"
                  onClick={handleCloseActionPopup}
                >
                  <i className="fa-solid fa-x"></i>
                </button>
                <div className="action-popup-input">
                  <label htmlFor="">Required Qty :</label>
                  <input
                    type="number"
                    min={0}
                    value={Qty}
                    onChange={(e) => setQty(e.target.value)}
                    disabled={loading}
                  />
                </div>
                <button
                  className="action-confirm-button"
                  onClick={() => handleSaveActionPopup()}
                  disabled={loading}
                >
                  {loading ? <LoadingSpinner size="small" text="" color="primary" /> : "Save"}
                </button>
              </div>
            </div>
          )}
          {showrawDeletePopup && (
            <div className="delete-raw-popup">
              <div className="delete-raw-content">
                <p>Are you sure you want to delete this raw material?</p>
                <p>{selectedRawMaterial?.component}</p>
                <div className="delete-popup-btn">
                  <button className="delete-popup-confirm" onClick={handlerawDeleteConfirm} disabled={loading}>
                    {loading ? <LoadingSpinner size="small" text="" color="primary" /> : "Confirm"}
                  </button>
                  <button className="delete-popup-cancel" onClick={handleClosePopup} disabled={loading}>
                    Cancel
                  </button>
                </div>

              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Devices;